import { tenantApi as api } from '../config/api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getManagedTenants: build.query<GetManagedTenantsApiResponse, GetManagedTenantsApiArg>({
      query: (queryArg) => ({
        url: `/managed/tenants`,
        params: {
          query: queryArg.query,
        },
      }),
    }),
    getManagedUsers: build.query<GetManagedUsersApiResponse, GetManagedUsersApiArg>({
      query: () => ({ url: `/managed/users` }),
    }),
    getSubdomainRecommendationForSalesforceAccount: build.query<
      GetSubdomainRecommendationForSalesforceAccountApiResponse,
      GetSubdomainRecommendationForSalesforceAccountApiArg
    >({
      query: (queryArg) => ({ url: `/subdomain/recommendation/salesforce_id/${queryArg.salesforceId}` }),
    }),
    getTenantBySubdomain: build.query<GetTenantBySubdomainApiResponse, GetTenantBySubdomainApiArg>({
      query: (queryArg) => ({ url: `/subdomain/${queryArg.subdomain}` }),
    }),
    listTenants: build.query<ListTenantsApiResponse, ListTenantsApiArg>({
      query: (queryArg) => ({
        url: `/tenants`,
        params: {
          query: queryArg.query,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createTenant: build.mutation<CreateTenantApiResponse, CreateTenantApiArg>({
      query: (queryArg) => ({ url: `/tenants`, method: 'POST', body: queryArg.createTenantDto }),
    }),
    getTenantLoginInfo: build.query<GetTenantLoginInfoApiResponse, GetTenantLoginInfoApiArg>({
      query: (queryArg) => ({
        url: `/tenants/login_info`,
        params: {
          email: queryArg.email,
        },
      }),
    }),
    deleteTenant: build.mutation<DeleteTenantApiResponse, DeleteTenantApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}`, method: 'DELETE' }),
    }),
    getTenantById: build.query<GetTenantByIdApiResponse, GetTenantByIdApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}` }),
    }),
    updateTenant: build.mutation<UpdateTenantApiResponse, UpdateTenantApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}`, method: 'PUT', body: queryArg.updateTenantDto }),
    }),
    getTenantActivitiesLogs: build.query<GetTenantActivitiesLogsApiResponse, GetTenantActivitiesLogsApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/activity_logs`,
        params: {
          section: queryArg.section,
          section_id: queryArg.sectionId,
          search: queryArg.search,
          cycle_id: queryArg.cycleId,
          action: queryArg.action,
          since: queryArg.since,
          group_skipped: queryArg.groupSkipped,
          exclude_enrolled_skips: queryArg.excludeEnrolledSkips,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    getTenantAnalytics: build.query<GetTenantAnalyticsApiResponse, GetTenantAnalyticsApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/analytics` }),
    }),
    getTenantAuthConfig: build.query<GetTenantAuthConfigApiResponse, GetTenantAuthConfigApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/auth-config` }),
    }),
    listTenantLanguages: build.query<ListTenantLanguagesApiResponse, ListTenantLanguagesApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/available_languages` }),
    }),
    upsertEmployeeIdConfig: build.mutation<UpsertEmployeeIdConfigApiResponse, UpsertEmployeeIdConfigApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/employee-id-config`,
        method: 'POST',
        body: queryArg.payload,
      }),
    }),
    getEmployeeIdConfig: build.query<GetEmployeeIdConfigApiResponse, GetEmployeeIdConfigApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/get-employee-id-config` }),
    }),
    deleteAllTenantNotes: build.mutation<DeleteAllTenantNotesApiResponse, DeleteAllTenantNotesApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/notes`, method: 'DELETE' }),
    }),
    listTenantNotes: build.query<ListTenantNotesApiResponse, ListTenantNotesApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/notes` }),
    }),
    createTenantNote: build.mutation<CreateTenantNoteApiResponse, CreateTenantNoteApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/notes`,
        method: 'POST',
        body: queryArg.createTenantNoteDto,
      }),
    }),
    deleteTenantNote: build.mutation<DeleteTenantNoteApiResponse, DeleteTenantNoteApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/notes/${queryArg.tenantNoteId}`, method: 'DELETE' }),
    }),
    getTenantNoteById: build.query<GetTenantNoteByIdApiResponse, GetTenantNoteByIdApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/notes/${queryArg.tenantNoteId}` }),
    }),
    updateTenantNote: build.mutation<UpdateTenantNoteApiResponse, UpdateTenantNoteApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/notes/${queryArg.tenantNoteId}`,
        method: 'PUT',
        body: queryArg.updateTenantNoteDto,
      }),
    }),
    getTenantSalesforceById: build.query<GetTenantSalesforceByIdApiResponse, GetTenantSalesforceByIdApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/salesforce` }),
    }),
    getTenantTheme: build.query<GetTenantThemeApiResponse, GetTenantThemeApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/theme` }),
    }),
    upsertTenantTheme: build.mutation<UpsertTenantThemeApiResponse, UpsertTenantThemeApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/theme`, method: 'PATCH', body: queryArg.upsert }),
    }),
    deleteTenantLogo: build.mutation<DeleteTenantLogoApiResponse, DeleteTenantLogoApiArg>({
      query: (queryArg) => ({ url: `/tenants/${queryArg.tenantId}/themes/logo`, method: 'DELETE' }),
    }),
    upsertTenantLogo: build.mutation<UpsertTenantLogoApiResponse, UpsertTenantLogoApiArg>({
      query: (queryArg) => ({
        url: `/tenants/${queryArg.tenantId}/themes/logo`,
        method: 'POST',
        body: queryArg.bodyUpsertTenantLogo,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as enhancedApi }
export type GetManagedTenantsApiResponse = /** status 200 Successful Response */ TenantDto[]
export type GetManagedTenantsApiArg = {
  query?: string
}
export type GetManagedUsersApiResponse = /** status 200 Successful Response */ UserDto[]
export type GetManagedUsersApiArg = void
export type GetSubdomainRecommendationForSalesforceAccountApiResponse =
  /** status 200 Successful Response */ SubdomainRecommendationDto
export type GetSubdomainRecommendationForSalesforceAccountApiArg = {
  salesforceId: string
}
export type GetTenantBySubdomainApiResponse = /** status 200 Successful Response */ TenantIdDto
export type GetTenantBySubdomainApiArg = {
  subdomain: string
}
export type ListTenantsApiResponse = /** status 200 Successful Response */ TenantDto[] | PageTenantDto
export type ListTenantsApiArg = {
  query?: string
  page?: number
  size?: number
}
export type CreateTenantApiResponse = /** status 201 Successful Response */ CreateTenantResponseDto
export type CreateTenantApiArg = {
  createTenantDto: CreateTenantDto
}
export type GetTenantLoginInfoApiResponse = /** status 200 Successful Response */ TenantLoginInfoDto
export type GetTenantLoginInfoApiArg = {
  email: string
}
export type DeleteTenantApiResponse = unknown
export type DeleteTenantApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type GetTenantByIdApiResponse = /** status 200 Successful Response */ TenantDetailDto
export type GetTenantByIdApiArg = {
  tenantId: string
}
export type UpdateTenantApiResponse = /** status 200 Successful Response */ TenantDto
export type UpdateTenantApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  updateTenantDto: UpdateTenantDto
}
export type GetTenantActivitiesLogsApiResponse = /** status 200 Successful Response */ PageUserActivityLogDto | Page
export type GetTenantActivitiesLogsApiArg = {
  tenantId: string
  /** Section e.g training */
  section?: Section
  /** Section ID e.g training_id for training section */
  sectionId?: string
  /** Global search query to filter logs */
  search?: string
  /** Narrow the feed to these training cycles' events (the History tab's cycle multi-select); repeatable, values are ORed. Matches rows whose payload carries the cycle. Blank values are ignored (an empty selection means no filter). */
  cycleId?: (string | '')[]
  /** Only events with these actions; repeatable, values are ORed. Matches the `action` field of the response items. Blank values are ignored (an empty selection means no filter). */
  action?: (Action | '')[]
  /** Only events recorded after this moment. */
  since?: string
  /** Return AUTO_ENROLMENT_SKIPPED events as one item for each cycle, conflicting cycle and UTC day, with `data` a list of the skipped learners' payloads, oldest first. `total` then counts these items, not the events. An item's `id`, `created_at`, `timestamp` and actor fields are those of the newest event that matches the request, so `search` and `since` change them. */
  groupSkipped?: boolean
  /** Leave out AUTO_ENROLMENT_SKIPPED events whose learner now has a live enrolment in the event's cycle. */
  excludeEnrolledSkips?: boolean
  page?: number
  size?: number
}
export type GetTenantAnalyticsApiResponse = /** status 200 Successful Response */ TenantAnalyticsResponse
export type GetTenantAnalyticsApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type GetTenantAuthConfigApiResponse = /** status 200 Successful Response */ TenantAuthConfigDto
export type GetTenantAuthConfigApiArg = {
  tenantId: string
}
export type ListTenantLanguagesApiResponse = /** status 200 Successful Response */ LanguageDto[]
export type ListTenantLanguagesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type UpsertEmployeeIdConfigApiResponse = /** status 200 Successful Response */ EmployeeIdConfigDto
export type UpsertEmployeeIdConfigApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  payload: {
    [key: string]: boolean
  }
}
export type GetEmployeeIdConfigApiResponse = /** status 200 Successful Response */ EmployeeIdConfigDto
export type GetEmployeeIdConfigApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type DeleteAllTenantNotesApiResponse = unknown
export type DeleteAllTenantNotesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type ListTenantNotesApiResponse = /** status 200 Successful Response */ TenantNoteDto[]
export type ListTenantNotesApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type CreateTenantNoteApiResponse = /** status 201 Successful Response */ TenantNoteDto
export type CreateTenantNoteApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  createTenantNoteDto: CreateTenantNoteDto
}
export type DeleteTenantNoteApiResponse = unknown
export type DeleteTenantNoteApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  tenantNoteId: string
}
export type GetTenantNoteByIdApiResponse = /** status 200 Successful Response */ TenantNoteDto
export type GetTenantNoteByIdApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  tenantNoteId: string
}
export type UpdateTenantNoteApiResponse = /** status 200 Successful Response */ TenantNoteDto
export type UpdateTenantNoteApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  tenantNoteId: string
  updateTenantNoteDto: UpdateTenantNoteDto
}
export type GetTenantSalesforceByIdApiResponse = /** status 200 Successful Response */ TenantSalesforceDto
export type GetTenantSalesforceByIdApiArg = {
  tenantId: string
}
export type GetTenantThemeApiResponse = /** status 200 Successful Response */ TenantThemeDto
export type GetTenantThemeApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type UpsertTenantThemeApiResponse = /** status 200 Successful Response */ TenantThemeDto
export type UpsertTenantThemeApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  upsert: Upsert
}
export type DeleteTenantLogoApiResponse = unknown
export type DeleteTenantLogoApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
}
export type UpsertTenantLogoApiResponse = /** status 200 Successful Response */ UploadLogoDto
export type UpsertTenantLogoApiArg = {
  /** Tenant the request is scoped to. */
  tenantId: string
  bodyUpsertTenantLogo: BodyUpsertTenantLogo
}
export type TenantDto = {
  default_language_tag: string
  details: string
  id: string
  name: string
  salesforce_id: string
  subdomain: string
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type TrainingCycleStatus = 'planned' | 'running' | 'ended' | 'archived'
export type UserTrainingCycleDto = {
  cycle_id: string
  cycle_status: TrainingCycleStatus
  name: string
}
export type ValidUserRoles =
  | 'lawpilots_admin'
  | 'customer_success'
  | 'global_customer_manager'
  | 'customer_manager'
  | 'participant'
export type UserStatusEnum = 'Active' | 'Inactive' | 'Pending'
export type UserDto = {
  cycles?: UserTrainingCycleDto[]
  department?: string
  email?: string
  email_verified?: boolean
  employee_id?: string
  first_name: string
  id: string
  invited_at?: string
  is_bluecollar?: boolean
  is_external?: boolean
  language_tag: string
  last_name: string
  location?: string
  position?: string
  roles: ValidUserRoles[]
  status: UserStatusEnum
  units?: any[]
  updated_at: string
}
export type SubdomainRecommendationDto = {
  value: string
}
export type TenantIdDto = {
  id: string
  is_parent?: boolean
}
export type PageTenantDto = {
  items: TenantDto[]
  page?: number
  pages?: number
  size?: number
  total?: number
}
export type CreateTenantResponseDto = {
  default_language_tag: string
  details: string
  id: string
  name: string
  parent_id?: string
  salesforce_id: string
  subdomain: string
}
export type CreateTenantDto = {
  default_language_tag?: string
  details?: string
  name: string
  parent_id?: string
  salesforce_id: string
  subdomain: string
}
export type TenantLoginInfoDto = {
  id: string
  subdomain: string
}
export type TenantType = 'standalone' | 'parent' | 'child'
export type TenantDetailDto = {
  default_language_tag: string
  details: string
  id: string
  name: string
  salesforce_id: string
  subdomain: string
  tenant_type: TenantType
}
export type UpdateTenantDto = {
  default_language_tag: string
  details?: string
  name: string
  salesforce_id: string
  subdomain: string
}
export type TrainingParticipationLogDto = {
  completed_at?: string
  course_form_of_address?: string
  course_language_tag?: string
  id: string
  started_at?: string
}
export type TenantLogDto = {
  id: string
  name: string
}
export type TrainingLogDto = {
  code: string
  id: string
  internal_name: string
}
export type TrainingCycleLogDto = {
  due_date?: string
  end_date: string
  id: string
  name?: string
  start_date: string
  training_id: string
}
export type UserLogDto = {
  email?: string
  email_verified: boolean
  first_name: string
  id: string
  last_name: string
  roles: string[]
}
export type ActivityLogDataDto = {
  participation?: TrainingParticipationLogDto
  tenant?: TenantLogDto
  training?: TrainingLogDto
  training_cycle?: TrainingCycleLogDto
  user?: UserLogDto
}
export type UserActivityLogDto = {
  /** Action performed by the user */
  action: string
  /** Data related to the action */
  data?: string
  /** Email of the user who performed the action */
  email?: string
  /** Full name of the user who performed the action */
  full_name?: string
  id: string
  /** Roles of the user who performed the action */
  roles?: string
  /** Tenant ID of the user who performed the action */
  tenant_id: string
  /** Time when the action was performed */
  timestamp: string
  /** Training ID */
  training_id?: string
  /** Auto populated data related to the action */
  typed_data?: ActivityLogDataDto | ActivityLogDataDto[]
  /** User ID of the user who performed the action */
  user_id: string
}
export type PageUserActivityLogDto = {
  items: UserActivityLogDto[]
  page?: number
  pages?: number
  size?: number
  total?: number
}
export type Page = {
  items: any[]
  page?: number
  pages?: number
  size?: number
  total?: number
}
export type Section = 'Users' | 'Trainings' | 'Courses' | 'Tenants' | 'Units'
export type Action =
  | 'ASSIGNED_TRAINING'
  | 'UNASSIGNED_TRAINING'
  | 'UNASSIGNED_TRAINING_USER_FUTURE_CYCLES'
  | 'BULK_UNASSIGNED_TRAINING'
  | 'SENT_TRAINING_INVITATION'
  | 'SENT_TRAINING_REMINDER'
  | 'SENT_MANUAL_TRAINING_REMINDER'
  | 'SENT_CUSTOMER_MANAGER_INVITE'
  | 'SENT_ACTIVATION_EMAIL'
  | 'IMPORTED_USERS'
  | 'ARCHIVED_USER'
  | 'RECONCILED_ARCHIVED_USER'
  | 'UNARCHIVED_USER'
  | 'DELETED_USER'
  | 'UNLINKED_IDENTITY_PROVIDER'
  | 'UPDATED_USER'
  | 'CREATED_USER'
  | 'CREATED_OR_UPDATED_EMPLOYEE_ID_CONFIG'
  | 'CREATED_TRAINING'
  | 'UPDATED_TRAINING_SETTINGS'
  | 'ARCHIVED_TRAINING'
  | 'CREATED_CYCLE'
  | 'UPDATED_CYCLE_SETTINGS'
  | 'DELETED_CYCLE'
  | 'CUSTOMISED_CYCLE_EMAIL'
  | 'UPDATED_CYCLE_EMAIL'
  | 'RESET_CYCLE_EMAIL'
  | 'STARTED_COURSE'
  | 'COMPLETED_COURSE'
  | 'REMINDER_SENT'
  | 'CREATED_TENANT'
  | 'UPDATED_TENANT'
  | 'BULK_UNASSIGNED_USER'
  | 'TRAINING_RECORDS_EMAIL'
  | 'CREATED_UNITS'
  | 'UPDATED_UNIT'
  | 'ARCHIVED_UNIT'
  | 'CREATED_SALESFORCE_CREDENTIALS'
  | 'UPDATED_SALESFORCE_CREDENTIALS'
  | 'ARCHIVED_SALESFORCE_CREDENTIALS'
  | 'CSV_EXPORT_EMAIL_SENT'
  | 'CREATED_TENANT_RELATIONSHIP'
  | 'ARCHIVED_TENANT_RELATIONSHIP'
  | 'ADMIN_UPDATED_SUBSCRIPTION_DATES'
  | 'ADMIN_UPDATED_SUBSCRIPTION_LINE_LICENSES'
  | 'GRANTED_LINE_ITEM_ACCESS'
  | 'REVOKED_LINE_ITEM_ACCESS'
  | 'GLOBAL_ADMIN_CREATED'
  | 'GLOBAL_ADMIN_UPGRADED'
  | 'SENT_GLOBAL_ADMIN_INVITE'
  | 'UNASSIGNED_TRAINING_USERS_VIA_REVOKED_ACCESS'
  | 'REGENERATED_CERTIFICATE'
  | 'MANUALLY_COMPLETED_COURSE'
  | 'AUTO_ENROLMENT_SKIPPED'
  | 'AUTO_ENROLLED_VIA_GROUP'
export type TenantAnalyticsDto = {
  overall_training_completion_percentage?: number
  time_until_completion_days?: number
  total_assigned_learners?: number
  total_assigned_trainings?: number
  total_completed_training_learners?: number
  total_learners_count?: number
}
export type TenantAnalyticsResponse = {
  analytics: TenantAnalyticsDto
  tenant_id: string
}
export type TenantSsoProviderDto = {
  alias: string
  protocol: string
  vendor?: string
}
export type TenantAuthConfigDto = {
  allow_employee_id_login: boolean
  providers: TenantSsoProviderDto[]
  sso: boolean
}
export type LanguageDto = {
  display_in_ui: boolean
  display_name: string
  tag: string
}
export type EmployeeIdConfigDto = {
  completed: boolean
  content: object
  id: string
  tenant_id: string
}
export type TenantNoteDto = {
  id: string
  pinned_timestamp?: string
  tenant_id: string
  text: string
  timestamp: string
  user_id: string
  user_name: string
}
export type CreateTenantNoteDto = {
  is_pinned?: boolean
  text: string
}
export type UpdateTenantNoteDto = {
  pinned_timestamp?: string
  text: string
}
export type SalesforceAddress = {
  city: string
  country: string
  postal_code: string
  street: string
}
export type TenantSalesforceDto = {
  address: SalesforceAddress
  email: string
  id: string
  language: string
  name: string
  record_url?: string
}
export type TenantThemeDto = {
  color?: string
  logo_url?: string
  secondary_color?: string
}
export type Upsert = {
  color?: string
  secondary_color?: string
}
export type UploadLogoDto = {
  url?: string
}
export type BodyUpsertTenantLogo = {
  /** The tenant logo to be uploaded. */
  logo: Blob
}
export const {
  useGetManagedTenantsQuery,
  useGetManagedUsersQuery,
  useGetSubdomainRecommendationForSalesforceAccountQuery,
  useGetTenantBySubdomainQuery,
  useListTenantsQuery,
  useCreateTenantMutation,
  useGetTenantLoginInfoQuery,
  useDeleteTenantMutation,
  useGetTenantByIdQuery,
  useUpdateTenantMutation,
  useGetTenantActivitiesLogsQuery,
  useGetTenantAnalyticsQuery,
  useGetTenantAuthConfigQuery,
  useListTenantLanguagesQuery,
  useUpsertEmployeeIdConfigMutation,
  useGetEmployeeIdConfigQuery,
  useDeleteAllTenantNotesMutation,
  useListTenantNotesQuery,
  useCreateTenantNoteMutation,
  useDeleteTenantNoteMutation,
  useGetTenantNoteByIdQuery,
  useUpdateTenantNoteMutation,
  useGetTenantSalesforceByIdQuery,
  useGetTenantThemeQuery,
  useUpsertTenantThemeMutation,
  useDeleteTenantLogoMutation,
  useUpsertTenantLogoMutation,
} = injectedRtkApi
